export default "__VITE_ASSET__BBrqEOS4__"